package com.essntl.core.unsplash.ui

import com.essntl.core.unsplash.domain.models.Picture
import com.essntl.core.utils.viewmodel.PaginationState

data class UnsplashState(
    val getAllPicture: PaginationState<Picture> = PaginationState(),
)